export default {"src":"/_next/static/media/hn.612424f3.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};